import React from "react";
import PropTypes from "prop-types";
import MapBlocksToComponents from "Helpers/BlockHelper";
import { PageTransition } from "Animations";

let StartPage = ({ 
  ShowHero,
  ElementArea,
}) => {
  return (
    <>     
      <PageTransition>
        {ElementArea.length > 0 && MapBlocksToComponents(ElementArea, undefined, undefined, ShowHero)}
      </PageTransition>
    </>
  );
};

StartPage.propTypes = {
  Heading: PropTypes.string,
  Image: PropTypes.object,
  ElementArea: PropTypes.array,
  StartpagePuffs: PropTypes.array,
  Ingress: PropTypes.string,
};

export default StartPage;
